import * as prismic from "@prismicio/client";

// -- Prismic API endpoint
const apiEndpoint = "https://pennsylvania-squeeze.cdn.prismic.io/api/v2";
// -- Access Token if the repository is not public
const accessToken =
  "MC5hSkpESVJJQUFDQUF4eTZ0.77-9I--_vWfvv71j77-9KWDvv70xFgTvv73vv73vv71XMe-_ve-_vWxn77-977-977-977-977-977-977-9Hu-_ve-_vQ";
// -- Prismic Client
const PrismicClient = prismic.createClient(apiEndpoint, { accessToken });

export default PrismicClient;
